export default "__VITE_ASSET__gEh6ZkZ9__"